import styled from 'styled-components';

export const PreviewMarker = styled.span`
  display: inline-block;
  vertical-align: top;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(p: any) => p.color};
`;
